export default __webpack_public_path__ + "static/media/at.9fae77ce.svg";